<mat-card appearance="raised" class="card" [ngClass]="{'disabled': disabled, 'module-card-warning': !module?.IsLatestServerVersion && !disabled}">
  <mat-card-title class="card-title">
    @if (!disabled && !module.Loading && !module.HasError) {
      <div id="module-link-{{module.ModuleId}}" [attr.data-qa-id]="'modules-card-link-' + module.ModuleId" class="moduleName" [routerLink]="[module.ModuleId, module.MajorBaseVersion]"> {{module.ModuleName | translate: 'Text' | async}} </div>
    }
    @if (disabled || module.Loading || module.HasError) {
      <div class="moduleName"> {{module.ModuleName | translate: 'Text' | async}} </div>
    }
    @if (syncEnabled) {
      <div class="aw-sync-check">
        @if (!module.Loading && !module.HasError) {
          <div>
            @if (!module.IsPartiallySynced && !module.IsFullySynced) {
              <mat-icon color="warn" id="module-no-sync-{{module.ModuleId}}">cloud_off</mat-icon>
            }
            @if (module.IsPartiallySynced && !module.IsFullySynced) {
              <mat-icon color="primary" id="module-part-sync-{{module.ModuleId}}">cloud_done</mat-icon>
            }
            @if (module.IsFullySynced) {
              <mat-icon color="accent" id="module-sync-{{module.ModuleId}}">cloud_done</mat-icon>
            }
          </div>
        }
        @if (!module.Loading && module.HasError) {
          <div>
            <mat-icon color="warn">error</mat-icon>
          </div>
        }
        @if (module.Loading) {
          <div>
            <aw-spinner></aw-spinner>
          </div>
        }
      </div>
    }
  </mat-card-title>
  <mat-card-subtitle class="card-subtitle">
    {{module.ModuleDescription | translate: 'Text' | async}}
  </mat-card-subtitle>
  <mat-card-content class="card-content">
    <div class="card-image-container">
      @if (!disabled) {
        <img [routerLink]="[module.ModuleId, module.MajorBaseVersion]" [src]="getModuleImageSrc()" [attr.alt]="module.ModuleName | translate: 'Text' | async" />
      }
      @if (disabled) {
        <img [src]="getModuleImageSrc()" [attr.alt]="module.ModuleName | translate: 'Text' | async" />
      }
      <!--            <img *ngIf="!disabled" [routerLink]="[module.ModuleId, module.MajorBaseVersion]" src="../../../../../../assets/img/{{module.ModuleId}}.svg" />-->
      <!--            <img *ngIf="disabled" src="../../../../../../assets/img/{{module.ModuleId}}.svg" />-->
    </div>
    <ng-content select=".card-component-data">
    </ng-content>
  </mat-card-content>
  <mat-card-actions class="card-actions">
    <div>
      @if (syncEnabled) {
        <button
          mat-button
          class="mat-accent create-package-button"
          [attr.data-qa-id]="'modules-btn-create-package-' + module.ModuleId"
          (click)="module.IsPartiallySynced && createPackage()"
          [disabled]="!module.IsPartiallySynced || !module.Changes || creatingPackage"
          id="create-package">
          @if (!creatingPackage) {
            <span>Create Package</span>
          }
          @if (creatingPackage) {
            <mat-spinner diameter="20"></mat-spinner>
          }
        </button>
      }
    </div>
    <button mat-icon-button [attr.data-qa-id]="'modules-btn-options-' + module.ModuleId" [matMenuTriggerFor]="menu" id="module-card-options-{{module.ModuleId}}">
      <mat-icon>more_vert</mat-icon>
      <mat-menu #menu="matMenu">
        @if (syncEnabled) {
          <button mat-menu-item (click)="resetModule()" id="module-card-reset-{{module.ModuleId}}">
            <mat-icon color="primary">undo</mat-icon>
            <span>Reset To Latest</span>
          </button>
        }
        <ng-content select=".card-component-actions">
        </ng-content>
      </mat-menu>
    </button>
  </mat-card-actions>
</mat-card>
